import configModel from 'gmfapi/store/config';

configModel.getConfig().subscribe({
  next: (config?: any) => {
    if (config) {
      const tenant = config.tenantOptions;

      // Update document title
      if (tenant && tenant.title !== undefined) {
        const titleElement = document.querySelector('title');
        if (titleElement) {
          titleElement.remove();
        }
        document.title = tenant.title;
      }

      // Update favicon
      if (config.geogrCustomFaviconUrl) {
        let link = document.querySelector("link[rel*='icon']") as HTMLLinkElement;

        if (!link) {
          link = document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'icon';
          document.head.appendChild(link);
        }

        link.href = config.geogrCustomFaviconUrl;
      }
    }
  },
});
